import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import Aurora from '../fx/Aurora';
import Particles from '../fx/Particles';
import SplitText from '../fx/SplitText';
import Logo from '../ui/Logo';

/** Split-screen wrapper used by Login + Signup. */
export default function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      {/* Left — form */}
      <div className="relative flex flex-col justify-center px-6 py-12 sm:px-12 lg:px-16">
        <Link to="/" className="absolute left-6 top-6 sm:left-12 lg:left-16">
          <Logo />
        </Link>
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, ease: 'easeOut' }}
          className="mx-auto w-full max-w-sm"
        >
          <h1 className="font-display text-3xl font-semibold tracking-tight">{title}</h1>
          {subtitle && <p className="mt-2 text-content-muted">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-content-muted">{footer}</div>}
        </motion.div>
      </div>

      {/* Right — brand panel */}
      <div className="relative hidden overflow-hidden lg:block">
        <Aurora intensity={0.85} />
        <Particles className="opacity-60" />
        <div className="relative z-10 flex h-full flex-col justify-end p-16">
          <div className="inline-flex w-fit items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-sm text-content-muted backdrop-blur">
            <Sparkles className="h-4 w-4 text-brand-300" />
            Aether Studio
          </div>
          <SplitText
            text="One prompt, infinite creation."
            inView={false}
            stagger={0.06}
            className="mt-6 max-w-md font-display text-4xl font-semibold leading-tight"
          />
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.8 }}
            className="mt-4 max-w-md text-content-muted"
          >
            The AI creative platform that turns words into images, soundtracks, and working code.
          </motion.p>
        </div>
      </div>
    </div>
  );
}
